import { RedPacketEnvelopeCard } from "./RedPacketEnvelopeCard";

export function RedPacketEnvelopeGrid({
  count,
  selectedIndex,
  disabled,
  variant = "newbie-step6",
  onSelect
}: {
  count: number;
  selectedIndex: number | null;
  disabled?: boolean;
  variant?: "newbie-step6" | "standard";
  onSelect: (index: number) => void;
}) {
  return (
    <div className="rg-redpacket-grid" data-count={count} data-variant={variant}>
      {Array.from({ length: count }, (_, index) => (
        <RedPacketEnvelopeCard
          key={index}
          index={index}
          selected={selectedIndex === index}
          disabled={disabled}
          variant={variant}
          onClick={() => onSelect(index)}
        />
      ))}
    </div>
  );
}
